import React from 'react';
import styled from 'styled-components/macro';
import { SearchBarGlobal } from 'components/molecules';

const NavTop = () => (
  <NavTopWrapper>
    <SearchBarGlobal />
  </NavTopWrapper>
);

const NavTopWrapper = styled.div`
  margin-bottom: ${props => props.theme.spacing.m};
`;

export default NavTop;
